
import {Component, Vue, Watch} from 'vue-property-decorator';
import {AlertingMeter} from '@/data/models/meter';

/** Onglet « Compteurs en alerte » : compteurs sans données depuis plus de 24 h. */
@Component({})
export default class AdminAlertingMeters extends Vue {
  headers = [
    {text: 'Compteur', value: 'meterName'},
    {text: 'Dernière réception', value: 'fromNow'},
    {text: '', value: 'action', align: 'right', sortable: false},
  ];

  meters: Array<AlertingMeter> = [];
  loading = true;

  // Mise en cache locale pour un affichage immédiat pendant le chargement
  @Watch('meters')
  onMetersChange(value: Array<AlertingMeter>): void {
    localStorage.setItem('alertingMeters', JSON.stringify(value));
  }

  mounted(): void {
    const cachedMeters = localStorage.getItem('alertingMeters');
    if (cachedMeters) {
      this.meters = (JSON.parse(cachedMeters) as Partial<AlertingMeter>[]).map((it) => AlertingMeter.map(it));
    }
    this.getMeters();
  }

  getMeters(): void {
    this.loading = true;
    this.$dao.logs.getAlertMeters().then((meters: Array<AlertingMeter>) => {
      meters.sort((a, b) => b.lastInsert.getTime() - a.lastInsert.getTime());
      this.meters = meters;
    }).finally(() => this.loading = false);
  }

  showMeter(id: string): void {
    this.$router.push({name: 'detailMeter', params: {buildingId: 'supervision', meterId: id}});
  }

  showBuilding(id: string): void {
    this.$router.push({name: 'listMeters', params: {buildingId: id}});
  }
}
